import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CareCardConfig } from '@zipari/shared-ds-util-care-card';
import { copyText } from '../../care-card.constants';

@Component({
  selector: 'care-card-card',
  templateUrl: './card.component.html',
  styleUrls: ['../../care-card.component.scss'],
})
export class CareCardCardComponent implements OnInit {
  @Input() config: CareCardConfig;
  @Input() providerType: string;
  @Output() addPCPClicked: EventEmitter<null> = new EventEmitter();

  title = '';
  noProviderText = '';
  addProviderText = '';
  icon = 'hospital';

  ngOnInit(): void {
    this.setDefaultValues();
  }

  private setDefaultValues() {
    if (this.providerType === 'dentist') {
      this.title = this.config.dental_title || copyText.dentistTitle;
      this.noProviderText =
        this.config.no_dentist_text || copyText.noDentistSelected;
      this.addProviderText =
        this.config.add_dentist_text || copyText.addDentist;
    } else {
      this.title = this.config.pcp_title || copyText.pcpTitle;
      this.noProviderText = this.config.no_pcp_text || copyText.noPcpSelected;
      this.addProviderText = this.config.add_pcp_text || copyText.addPcp;
    }
  }
}
